import { render, staticRenderFns } from "./OrganizationPhoneEdit.vue?vue&type=template&id=bf21ed4a&"
import script from "./OrganizationPhoneEdit.vue?vue&type=script&lang=js&"
export * from "./OrganizationPhoneEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports